export default __webpack_public_path__ + "static/media/gm.b5a4f9a4.png";